exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-autocomplete li[data-v-72ad609c] {\n  line-height: normal;\n  padding: 7px;\n}\n.my-autocomplete .value[data-v-72ad609c] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.my-autocomplete .link[data-v-72ad609c] {\n  font-size: 12px;\n  color: #b4b4b4;\n}\n\n/* Remove arrows on number input */\n\n/* Chrome, Safari, Edge, Opera */\ninput[data-v-72ad609c]::-webkit-outer-spin-button,\ninput[data-v-72ad609c]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  /*margin: 0; !* Remove left over margin  *!*/\n}\n\n/* Firefox */\ninput[type=number][data-v-72ad609c] {\n  -moz-appearance: textfield;\n}\n", ""]);

// exports
